export const initialState = (state, backups = {}) => {
  return {
    ...state,
    backupPlans: [],
    general: {
      inheritance: {
        inherited: false,
        overridden: false,
        sourcePolicyId: null,
      },
    },
    ...backups,
  }
}
